<template>
    <div class="reset-success">
        <el-card shadow="always">
            <div slot="header" class="clearfix card-title">
                <span>{{ title }}</span>
            </div>
            <div class="sign-form-wrap">
                <div class="reset-success-tips">
                    <i class="el-icon-success"></i>
                    <h3 class="tips-text">{{ $t('Form.ResetSuccessTips') }}</h3>
                </div>
            </div>
            <div class="card-footer">
                <el-button v-waves class="card-btn-confirm" type="primary" @click="toLogin">{{ $t('Button.ToLogin') }}</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
import waves from '@/directive/waves' // Waves directive
import { FormMixin } from '@/mixins'

export default {
    props: {
        title: { type: String, default: '' },
    },
    directives: { waves },
    mixins: [FormMixin],
    name: 'ResetSuccessCard',
    methods: {
        handleBackClick() {
            this.$emit('backClick')
        },
    },
}
</script>

<style lang="scss" scoped>
$color-theme: #4da1ff;

.reset-success {
    .card-footer {
        padding: 30px 0 20px 0;
        .card-btn-confirm {
            width: 60%;
        }
        .card-btn-to-register {
        }
    }
    .el-form-item {
        margin-bottom: 30px;
    }

    .sign-form-wrap {
        .reset-success-tips {
            text-align: center;
            /*padding-left: 13%;*/
            .el-icon-success {
                font-size: 50px;
                color: $color-theme;
            } //el-icon-success
            .tips-text {
                margin-top: 15px;
                margin-bottom: 35px;
            } //tips-
        } //reset-success-tips
    } //sign-form-wrap
}
</style>
